<template>
  <div class="tuolele-main-box company-manage">
    <div class="tuolele-main-search">
      <el-row type="flex">
        <el-select v-model="search.id">
          <el-option label="选择分组" value="" />
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-button
          type="primary"
          @click="editCompany('add')"
        >新增公司</el-button>
      </el-row>
    </div>
    <div class="tuolele-main-content">
      <el-table :data="tableData" border stripe>
        <el-table-column prop="name" label="分组名称" />
        <el-table-column
          prop="province_name"
          label="公司名称"
        />
        <el-table-column prop="city_name" label="超管账号" />
        <el-table-column prop="area_name" label="描述" />
        <el-table-column prop="address" label="可批改张数" />
        <el-table-column
          prop="address"
          label="正式余额(乐币)"
        />
        <el-table-column
          prop="address"
          label="赠送余额(乐币)"
        />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="addBalance('edit', scope.row)"
            >增加余额</el-button>
            <el-button
              type="text"
              @click="addCorrectCount('edit', scope.row)"
            >增加张数</el-button>
            <el-button
              type="text"
              @click="editCompany('edit', scope.row)"
            >编辑</el-button>
            <el-button
              type="text"
              @click="deleteCompany('edit', scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="增加余额" :visible.sync="dialogVisible" width="30%">
        <div class="order-detail-item">
          <div class="color-black bold font-size16 order-detail-item-title">
            付款金额(金额)
          </div>
          <el-input v-model="price1" type="number" clearable />
        </div>
        <div class="order-detail-item">
          <div class="color-black bold font-size16 order-detail-item-title">
            增加金额(乐币)
          </div>
          <el-input v-model="price2" type="number" clearable />
        </div>
        <p>
          增加余额需要大于等于付款金额<br>（乐币金额-人民币金额的部分将作为赠送余额添加至用户账户余额中）
        </p>
        <el-button
          type="primary"
          class="el-button-confirm"
          @click="confirmAddBalance"
        >确定</el-button>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CompanyManage',
  data() {
    return {
      search: {
        id: ''
      },
      companyList: [
        { id: '111', name: 'tob111' },
        { id: '222', name: 'tob222' }
      ],
      tableData: [],
      price1: '',
      price2: '',
      dialogVisible: false
    }
  },
  mounted() {
    this.getShopList()
  },
  methods: {
    getShopList() {
      this.$http.getShopList({ name: this.search.name }).then(res => {
        this.tableData = res.data
      })
    },
    editCompany(type, row) {
      const id = row ? row.id : ''
      this.$router.push({
        path: 'companyAdd',
        query: { id: id, type: type }
      })
    },
    deleteCompany() {
      this.$confirm('确定要删除公司吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        // this.$http.accountRemove({ uid: row.uid }).then(res => {
        //   if (res.code == 200) {
        //     this.$message({
        //       type: "success",
        //       message: "删除成功"
        //     });
        //     this.getAccountList();
        //   }
        // });
      })
    },
    addCorrectCount() {
      this.$prompt('增加张数', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '请输入数字格式',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '执行中...'
            // HTTP.http_post({
            //     url: HTTP_URL.modifyTicker,
            //     data: {
            //         account_id: row.account_id,
            //         reason: instance.inputValue
            //     },
            //     success: function (ret) {
            //         instance.confirmButtonLoading = false;
            //         done();
            //         that.reportStudentList();
            //     }
            // });
          } else {
            instance.confirmButtonLoading = false
            done()
          }
        }
      }).then(() => {
        this.$message({
          type: 'success',
          message: '增加成功'
        })
      })
    },
    addBalance() {
      this.dialogVisible = true
      this.price1 = ''
      this.price2 = ''
    },
    confirmAddBalance() {
      if (!this.price1 || !this.price2) {
        this.$message({
          type: 'info',
          message: '请输入金额！'
        })
        return
      }
      if (this.price1 > this.price2) {
        this.$message({
          type: 'info',
          message: '增加余额需要大于等于付款金额'
        })
        return
      }
      this.dialogVisible = false
    }
  }
}
</script>
<style lang="scss">
.company-manage {
  .el-select {
    margin-right: 20px;
  }
  .el-dialog {
    .el-input {
      width: 250px;
      margin: 10px 0;
    }
    p {
      color: red;
      margin-bottom: 20px;
    }
  }
}
</style>
